<p-overlayPanel #op [style]="{'border-radius': '12px'}">
    <ng-template pTemplate="content">
        <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="Propiedades">
                <div class="custom-menu-text-1"><a href="">Casas</a></div>
                <div class="custom-menu-text-1"><a href="">Departamentos</a></div>
                <div class="custom-menu-text-1"><a href="">Locales comerciales</a></div>
                <div class="custom-menu-text-1"><a href="">Oficinas</a></div>
                <div class="custom-menu-text-1"><a href="">Terrenos</a></div>
                <div class="custom-menu-text-1"><a href="">Parqueos</a></div>
                <div class="custom-menu-text-1"><a href="">Galpones</a></div>
                <br><br>
                <div class="custom-menu-text-2"><a href="">Comprar</a></div>
                <div class="custom-menu-text-2"><a href="">Alquilar</a></div>
                <div class="custom-menu-text-2"><a href="">Anticretico</a></div>
                <div class="custom-menu-text-2"><a href="">Remates bancarios</a></div>
                <div class="custom-menu-text-2"><a href="">Subir tu propiedad</a></div>
                <div class="custom-menu-text-2" *ngIf="!isUserLoggedIn">
                    <a (click)="navigateToLoginTab()"><strong>Iniciar sesión</strong></a></div>
            </p-tabPanel>
            <p-tabPanel header="Conocenos">
                <div class="custom-menu-text-1"><a href="">Quienes somos</a></div>
                <div class="custom-menu-text-1"><a href="">Como funciona</a></div>
                <div class="custom-menu-text-1"><a href="">Nuestros planes</a></div>
                <br><br>
                <div class="custom-menu-text-2"><a href="">Comprar</a></div>
                <div class="custom-menu-text-2"><a href="">Alquilar</a></div>
                <div class="custom-menu-text-2"><a href="">Anticretico</a></div>
                <div class="custom-menu-text-2"><a href="">Remates bancarios</a></div>
                <div class="custom-menu-text-2"><a href="">Subir tu propiedad</a></div>
            </p-tabPanel>
            <p-tabPanel header="Indices">
                <div class="custom-menu-text-1"><a href="">Dolar/Metro cuadrado</a></div>
                <div class="custom-menu-text-1"><a href="">XYZ</a></div>
                <div class="custom-menu-text-1"><a href="">ABC</a></div>
                <div class="custom-menu-text-1"><a href=""><u>Ver mas</u></a></div>
                <br><br>
                <div class="custom-menu-text-2"><a href="">Comprar</a></div>
                <div class="custom-menu-text-2"><a href="">Alquilar</a></div>
                <div class="custom-menu-text-2"><a href="">Anticretico</a></div>
                <div class="custom-menu-text-2"><a href="">Remates bancarios</a></div>
                <div class="custom-menu-text-2"><a href="">Subir tu propiedad</a></div>
            </p-tabPanel>
            <p-tabPanel header="Planes">
                <div class="custom-menu-text-1"><a href="">Basico</a></div>
                <div class="custom-menu-text-1"><a href="">Premium</a></div>
                <div class="custom-menu-text-1"><a href="">Pro+</a></div>
                <div class="custom-menu-text-1"><a href=""><u>Leer mas</u></a></div>
                <br><br>
                <div class="custom-menu-text-2"><a href="">Comprar</a></div>
                <div class="custom-menu-text-2"><a href="">Alquilar</a></div>
                <div class="custom-menu-text-2"><a href="">Anticretico</a></div>
                <div class="custom-menu-text-2"><a href="">Remates bancarios</a></div>
                <div class="custom-menu-text-2"><a href="">Subir tu propiedad</a></div>
            </p-tabPanel>
<!--            <p-tabPanel>-->
<!--                <ng-template pTemplate="header">-->
<!--                    <i class="pi pi-search"></i>-->
<!--                </ng-template>-->
<!--            </p-tabPanel>-->
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-user"></i>
                </ng-template>
                <ng-template pTemplate="content" *ngIf="isUserLoggedIn">
                    <app-personal-data
                        [isMenu]="true"></app-personal-data>
                </ng-template>
                <ng-template pTemplate="content" *ngIf="!isUserLoggedIn">
                    <app-login></app-login>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
    </ng-template>
</p-overlayPanel>
